<template>
  <CRow>
    <CNavbar
      style="position: fixed; top:0px; left: 0; right: 0; z-index: 1040;"
      expandable="md"
      color="white"
      class="shadow"
      v-if="selectedItem"
    >
      <CNavbarBrand class="text-dark">
        <FontAwesomeIcon 
          :icon="['fas', 'times']" 
          size="lg"
          style="cursor: pointer;"
          @click="selectedItem = null"
        />
        <span style="margin-left: 10px;">1 Selected</span>
      </CNavbarBrand>
      <CCollapse navbar>
        <!-- Right aligned nav items -->
        <CNavbarNav class="ml-auto">
          <CForm inline class="align-middle">
            <CButton
              v-if="enabledApply"
              color="primary" 
              class="my-2 my-sm-0" 
              type="submit"
              @click="applyImageAction"
            >Apply
            </CButton>
            <CButton
              v-if="enabledDelete"
              color="danger" 
              class="my-2 my-sm-0" 
              type="button"
              @click="deleteImageAction"
            >Delete
            </CButton>
          </CForm>
        </CNavbarNav>
      </CCollapse>
    </CNavbar>
    <CCol col="12">
      <CCard>
        <CCardBody>
            <vue-dropzone 
              ref="myVueDropzone" 
              id="dropzone" 
              :key="loggedInUser && loggedInUser.jwt"
              :options="dropzoneOptions"
              @vdropzone-queue-complete="onUploadQueueSuccess"
            ></vue-dropzone>
            <CRow 
              style="margin: 0px;" 
              v-for="key in Object.keys(imageMap)" 
              :key="key" 
              v-viewer="{navbar: false, toolbar: false,}"
            >
              <CCol col="12">
                <h4 style="padding-top: 10px;">{{key}}</h4>
              </CCol>
               <CCol lg="3" md="4" sm="6" v-for="image in imageMap[key]" :key="image.url" style="padding: 0px;">
                  <div class="app-image">
                    <FontAwesomeIcon
                      v-if="selectedItem == image || hoveredItem == image"
                      :icon="['fas', 'check-circle']" 
                      :class="selectedItem == image ? 'text-primary' : 'text-light'" 
                      size="lg"
                      style="cursor: pointer; position: absolute; left: 10px; top: 10px;"
                      @mouseleave="hoveredItem = null"
                      @click="; if (selectedItem == image) {
                        selectedItem = null; 
                        selectedItemKey = null;
                      } else {
                        selectedItem = image
                        selectedItemKey = key
                      } "
                    />
                    <FontAwesomeIcon
                      v-if="selectedItem != image && hoveredItem != image"
                      :icon="['far', 'circle']" 
                      class="text-light" 
                      size="lg"
                      style="cursor: pointer; position: absolute; left: 10px; top: 10px;"
                      @mouseover="hoveredItem = image"
                    />
                    <lazy-component>
                      <img 
                        :src="image.url"
                        :alt="image.title"
                      />
                    </lazy-component>
                  </div>
                </CCol>
            </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<style>
  .app-image {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    padding: 1px;
  }
  .app-image img {
    flex-shrink: 0;
    -webkit-flex-shrink: 0;
    max-width: 100%;
  }
</style>

<script>
import Vue from 'vue'
import { mapState, mapActions, mapMutations, } from 'vuex'
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import { ServiceHost } from '../../api/util'
import { getCookie } from '../../util'

Vue.use(Viewer)

export default {
  name: 'ImageList',
  components: {
    vueDropzone,
  },
  props: {
    enabledApply: {
      type: Boolean,
      default: false,
    },
    enabledDelete: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      files: [],
      selectedItem: null,
      selectedItemKey: null,
      hoveredItem: null,
    }
  },
  computed: {
    ...mapState({
      loggedInUser: state => state.loggedInUser,
      imageMap: state => state.image.imageMap,
    }),
    dropzoneOptions() {
      const jwt = getCookie('_admin_jwt')
      return {
          url: ServiceHost + "/api/image",
          thumbnailWidth: 150,
          maxFilesize: 3,
          headers: {
            Authorization: 'BEARER ' + jwt,
          },
          acceptedFiles: ".jpg, .jpeg, .png",
      }
    },
  },
  methods: {
    ...mapActions({
      getImageMap: 'image/getImageMap',
      deleteImage: 'image/deleteImage',
    }),
    ...mapMutations({}),
    goBack() {
    },
    onFormChange () {
    },
    onUploadQueueSuccess () {
      this.getImageMap().then(() => {
        this.$refs.myVueDropzone.removeAllFiles()
      })
    },
    applyImageAction () {
      const funcNum = this.$route.query.CKEditorFuncNum
      const imageUrl = this.selectedItem.url
      if (funcNum && window.opener && window.opener.CKEDITOR) {
        window.opener.CKEDITOR.tools.callFunction(funcNum, imageUrl)
        window.close()
      } else if (window.opener.UPDATE_IMAGE_ACTION) {
        window.opener.UPDATE_IMAGE_ACTION(imageUrl)
        window.close()
      }
    },
    deleteImageAction () {
      this.deleteImage({
        key: this.selectedItemKey, 
        imageItem: this.selectedItem,
      }).then(() => {
        this.selectedItemKey = null
        this.selectedItem = null
      })
    },
  },
  mounted() {
    this.getImageMap()
  },
  destroyed() {
  }
}
</script>
